import { render, staticRenderFns } from "./TrainCarHopperFull.vue?vue&type=template&id=f49c56b6&scoped=true"
import script from "./TrainCarHopperFull.vue?vue&type=script&lang=js"
export * from "./TrainCarHopperFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49c56b6",
  null
  
)

export default component.exports